var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],attrs:{"type":"text"},domProps:{"value":(_vm.searchText)},on:{"input":[function($event){if($event.target.composing)return;_vm.searchText=$event.target.value},_vm.handleChange]}})])
}
var staticRenderFns = []

export { render, staticRenderFns }